module.exports = __webpack_public_path__ + "assets/img/saugesne-energija.d93eb44d.jpg";